<!-- 购物车悬浮 -->
<!---->
<template>
  <div class="servebox" @click="goShop">
    <div class="inn">
      <div class="sign" v-if="num > 0">{{ num }}</div>
      <img src="@/imgs/shopFloat.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'shopFloat',
  components: {},
  data() {
    return {
      num: window.localStorage.getItem('shopNum') || 0
    }
  },
  computed: {},
  watch: {

  },
  methods: {
    // 点击去购物车
    goShop() {
      if (!window.localStorage.getItem('token')) {
        this.$message.info('请先登录！')
        return this.$router.push('/login')
      }
      this.$router.push({
        path: '/userIndex',
        query: {
          leftTab: 11,
        }
      })
    },
  },
  created() {
  },
  mounted() {
    window.addEventListener('setItemEvent', (e) => {
      // console.log(e);
      if (e.key == 'shopNum') {
        this.num = e.newValue
      }
    })
    // setInterval(function () {
    //   window.localStorage.setItem('shopNum', Math.random())
    // }, 3000)
  }
}
</script> 

<style scoped lang='scss'>
.servebox {
  position: fixed;
  right: 60px;
  bottom: 185px;
  transition: all .5s;
  border-radius: 50%;
  font-size: 18px;
  height: 60px;
  width: 60px;
  background: #FFFFFF;
  /* color: #fff; */

  box-shadow: 1px 1px 10px 4px #e6e3e3;

  &:hover {
    background-color: #ccc;
  }

  .inn {
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: 50%;

    .sign {
      position: absolute;
      bottom: -3px;
      right: -3px;
      background-color: #FD2866;
      color: #fff;
      border-radius: 50%;
      font-size: 13px;
      text-align: center;
      width: 22px;
      height: 22px;
      line-height: 22px;
    }

    img {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/components/shopFloat.vue